import { gql } from "@/gql";

export const SALON_REVIEWS_QUERY = gql(`
  query SalonReviews($salonId: ID!, $input: SalonReviewListInput) {
    salonReviews(salonId: $salonId, input: $input) {
      nodes {
        id
        salonId
        reviewerName
        starRating
        comment
        reviewTime
        isHidden
        isSnoozed
        translatedComment
        translationChecked
        source
        google {
          googleReviewId
          reviewerPhotoUrl
          replyComment
          replyTime
        }
        createdAt
        updatedAt
      }
      nextCursor
      hasMore
    }
  }
`);

export const CREATE_SALON_REVIEW_MUTATION = gql(`
  mutation CreateSalonReview($input: CreateSalonReviewInput!) {
    createSalonReview(input: $input) {
      id
      salonId
      reviewerName
      starRating
      comment
      reviewTime
      isHidden
      isSnoozed
      source
      google {
        googleReviewId
        reviewerPhotoUrl
        replyComment
        replyTime
      }
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_SALON_REVIEW_MUTATION = gql(`
  mutation UpdateSalonReview($salonId: ID!, $id: ID!, $input: UpdateSalonReviewInput!) {
    updateSalonReview(salonId: $salonId, id: $id, input: $input) {
      id
      salonId
      reviewerName
      starRating
      comment
      reviewTime
      isHidden
      isSnoozed
      source
      google {
        googleReviewId
        reviewerPhotoUrl
        replyComment
        replyTime
      }
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_SALON_REVIEW_MUTATION = gql(`
  mutation DeleteSalonReview($salonId: ID!, $id: ID!) {
    deleteSalonReview(salonId: $salonId, id: $id)
  }
`);

export const SALON_REVIEW_STATS_QUERY = gql(`
  query SalonReviewStats($salonId: ID!, $input: SalonReviewStatsInput) {
    salonReviewStats(salonId: $salonId, input: $input) {
      averageRating
      count
      distribution
      unrepliedCount
    }
  }
`);
